/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-12-07 17:29:26
 * @LastEditTime: 2021-12-08 10:10:37
 * @LastEditors: 赵大壮
 */
String.prototype.nyIsEmpty = function (): boolean {
    var temp_string = this.trim();
    if (typeof temp_string == "undefined" || temp_string == null || temp_string == ""){
        return true;
    }
    else{
        return false;
    }
}